import React from 'react';
import './TextLockup.scss';
import { TweenLite } from 'gsap';

export default class TextLockup extends React.Component {

  componentDidMount = () => {
    TweenLite.set(this.refs.self,{opacity:0})
    TweenLite.to(this.refs.self,1,{opacity:1,ease:'easeOutExpo', delay: 1})
  }

  render() {
    return (
      <div className="TextLockup" ref="self">
        <header>
          <h2 className="superhead">Daimler Trucks North America</h2>
          <h1>Driving us<br/>forward</h1>
          <p>
            From Portland to Detroit to Mexico, our employees
            drive us forward. Daimler Trucks North America is
            proudly built on a culture where diversity thrives.
          </p>
        </header>

        <div className='ctas'>
          {/* <div className="cta" onClick={this.props.onLeanClick}>Learn More</div> */}
          <div className="cta" onClick={this.props.onWatchClick}>Watch Film</div>
        </div>

      </div>
    );
  }
}

